import "./index.css";
import "./styles/button.css";

import "./styles/form/base.css";
import "./styles/form/effects.css";
import "./styles/form/states.css";

import "./styles/typography.css";
import "./styles/custom.css";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeProvider";

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	sendDefaultPii: true,
});

declare const __APP_ENV__: string;
if (__APP_ENV__ === "prod") {
	document.title = "Autumn (P)";
} else if (__APP_ENV__ === "staging") {
	document.title = "Autumn (S)";
} else if (__APP_ENV__ === "dev") {
	document.title = "Autumn (Dev)";
}

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

const shouldInitializePostHog = process.env.NODE_ENV === "production";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ThemeProvider>
				{/* <App /> */}
				{shouldInitializePostHog ? (
					<PostHogProvider
						apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
						options={{
							api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
							autocapture: false,
							capture_pageview: false,
							capture_pageleave: false,
						}}
					>
						<App />
					</PostHogProvider>
				) : (
					<App />
				)}
				{/* <ReactQueryDevtools initialIsOpen={false} /> */}
			</ThemeProvider>
		</QueryClientProvider>
	</StrictMode>,
);
